module.exports = __webpack_public_path__ + "static/media/bersama.803435aa.svg";